.bar {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
  padding: var(--tuna-spacing-1) var(--tuna-spacing-2);
  border: 1px dashed var(--tuna-border-default);
  border-radius: var(--tuna-shape-radius-md);
}

/* Idle: nothing shown, but the live region stays in the document */
.idle {
  display: contents;
}

.row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.text,
.position {
  font-size: var(--tuna-typography-body2-fontSize);
}

.position {
  font-variant-numeric: tabular-nums;
}

.label {
  font-size: var(--tuna-typography-body2-fontSize);
  color: var(--tuna-content-secondary);
}

.notCounted {
  color: var(--tuna-content-secondary);
}

.reason {
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-content-secondary);
}

.actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--tuna-spacing-1);
  margin-left: auto;
}

/* "Writing options…": three empty ghost slots, outlined as ghost notes are */
.slot {
  display: inline-block;
  width: 2.5rem;
  height: 0.75rem;
  border: 1px dashed var(--tuna-border-default);
  border-radius: var(--tuna-shape-radius-sm);
  opacity: 0.5;
}

.liveRegion {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

/* Spec §9: 44px targets on a phone, ‹ and › included (Joni's review) */
@media (max-width: 599.95px) {
  .row button {
    min-width: 44px;
    min-height: 44px;
  }

  /* Joni's M4 audit: on a phone, "Keep replaces your melody." is its own row, above Keep and Discard */
  .replaces {
    flex-basis: 100%;
    order: -1;
  }
}
